import React from 'react';
import { useRecoilValue } from 'recoil';
import { loadingMessageAtom } from 'app/atoms/loadingMessageAtom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingMessageOverlay: React.FC = () => {
  const { isVisible, message } = useRecoilValue(loadingMessageAtom);

  if (!isVisible) return null;

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 20, color: 'white' }} spin />
  );

  return (
    <>
      {/* Background overlay to block user input and gray out the background */}
      <div className="fixed inset-0 bg-black bg-opacity-20 z-[9998] pointer-events-auto" />

      {/* Loading message component */}
      <div className="fixed top-6 left-1/2 transform -translate-x-1/2 z-[9999] flex items-center justify-center gap-3 px-6 py-4 shadow-lg bg-blue-600 rounded-3xl text-white text-sm font-bold min-w-[200px]">
        <span>{message}</span>
        <Spin indicator={antIcon} />
      </div>
    </>
  );
};

export default LoadingMessageOverlay;
